import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import initialState from './authPdfInitialState';
import { _setAuthPdfPrint } from './authPdfActions';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getAuthPdfForm = createAsyncThunk(
  'stop/getAuthPdfForm',
  async (params) => {
    const { pdfUrl, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(pdfUrl, config)
      .then((response) => {
        //console.log('######################## GET AUTH PDF FROM ' + pdfUrl)
        //console.log(response)
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    const data = await response.data;
    return data === undefined ? null : data;
  }
);

const authPdfSlice = createSlice({
  name: 'stop/cbpAuthPdfForm',
  initialState,
  reducers: {
    setAuthPdfPrint: _setAuthPdfPrint,
    resetAuthPdfForm: () => initialState,
  },
  extraReducers: {
    [getAuthPdfForm.fulfilled]: (state, action) => action.payload,
  },
});

export const { setAuthPdfPrint, resetAuthPdfForm } = authPdfSlice.actions;

export default authPdfSlice.reducer;
